import React from "react"
import { useState } from "react"
import styled from "styled-components"
import QuestionCard from "./QuestionCard"
import NextImg from "@/common/components/NextImg/index"
import QABackground from "./QABackground"
import BGimg from "@/common/assets/image/moneyFortune/web3Plus/QABG.webp"

export default function Questions({
  data,
  setPage,
  marks,
  setMarks,
  customFor
}) {
  const [questionNum, setQuestionNum] = useState(1)
  const [Animation, SetAnimation] = useState(false)

  return (
    <Wrapper className={Animation === true && "active"}>
      <BGWrapper>
        <QABackground />
        <BGIMGWrapper>
          <NextImg src={BGimg} />
        </BGIMGWrapper>
      </BGWrapper>

      {data?.map(({ number, question, type, answers }) => {
        const NextQuestion = () => {
          if (questionNum < data.length) {
            setTimeout(() => setQuestionNum(number + 1), 500)
          }
          if (questionNum === data.length) {
            setTimeout(() => {
              setPage()
            }, 500)
          }
        }

        return (
          questionNum === number && (
            <QuestionCard
              key={number}
              number={number}
              question={question}
              questionNum={questionNum}
              setQuestionNum={setQuestionNum}
              type={type}
              answers={answers}
              marks={marks}
              setMarks={setMarks}
              changeQuestion={NextQuestion}
              customFor={customFor}
            />
          )
        )
      })}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  gap: 100px;
  align-items: center;
  justify-content: center;
`

const BGWrapper = styled.div`
  background-color: #000;
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--vh);
  z-index: -1;
`
const BGIMGWrapper = styled.div`
  position: absolute;
  z-index: -1;
  width: 100%;
  top: 20vh;
  left: 0;
  height: 100%;
`
